import { ContentSource } from 'constants/tracking/content-sources'
import { Screen } from 'constants/tracking/screens'

type ItemUploadStartEventArgs = {
  screenName: Screen
  tempUuid?: string
}

type ItemUploadStartEventExtra = {
  upload_session_id?: string
  screen: Screen
}

export const itemUploadStartEventExtra = (args: ItemUploadStartEventArgs) => {
  const extra: ItemUploadStartEventExtra = {
    screen: args.screenName,
    upload_session_id: args.tempUuid,
  }

  return {
    event: 'user.upload_item.start',
    extra,
  }
}

type ItemUploadSubmitSuccessArgs = {
  edited?: boolean
  photoCount?: number
  videoCount?: number
  itemId?: number | string
  screen?: Screen
  tempUuid?: string
}

type ItemUploadSubmitSuccessExtra = {
  edited?: boolean
  photo_count?: number
  video_count?: number
  item_id?: number | string
  screen?: Screen
  upload_session_id?: string
}

export const itemUploadSubmitSuccess = (args: ItemUploadSubmitSuccessArgs) => {
  const extra: ItemUploadSubmitSuccessExtra = {
    edited: args.edited,
    photo_count: args.photoCount,
    video_count: args.videoCount,
    item_id: args.itemId,
    screen: args.screen,
    upload_session_id: args.tempUuid,
  }

  return {
    event: 'user.upload_item.submit_success',
    extra,
  }
}

export const itemUploadFillZipCodeFail = () => ({
  event: 'user.upload_item.fill_zip_code_fail',
})

type ItemUploadViewSimilarSoldItemEventArgs = {
  id: number | string
  screen?: Screen
  position: number
  contentSource: ContentSource
  uploadSessionId?: string
}

type ItemUploadViewSimilarSoldItemEventExtra = {
  id: number | string
  screen?: Screen
  position: number
  content_source: ContentSource
  upload_session_id: string | undefined
}

export const itemUploadViewSimilarSoldItemEvent = (
  args: ItemUploadViewSimilarSoldItemEventArgs,
) => {
  const { id, screen, position, contentSource, uploadSessionId } = args

  const extra: ItemUploadViewSimilarSoldItemEventExtra = {
    id,
    position,
    content_source: contentSource,
    upload_session_id: uploadSessionId,
  }

  if (screen) extra.screen = screen

  return { event: 'upload_form.user.view_similar_sold_item', extra }
}
